import axios from 'axios';
import constants from 'config/constants';
import { store } from 'index';
import { getGlobalCurrentBatchUtils } from 'utils/commonFunc';

const APIS = {
  updateGroup: '/api/admin/fee-group', // /${schoolId}
  getAllGroup: `/api/admin/fee-group`, // /{schoolId}
  updateFeeStructure: `/api/admin/fee-structure`, // /{schoolId}/{batchId}/{feeGroupId}
  getAllFeeStructureByGroupId: `/api/admin/fee-structure-by-group-id`, // /{schoolId}/{batchId}/{feeGroupId}
  updateFeeGroupToCourse: `/api/admin/assign-fee-group-to-course`, // /{schoolId}/{batchId}
  getAllCoursesForGroup: `/api/admin/assign-fee-group-to-course`, // /{schoolId}/{batchId}
  // This endpoint used to assign a student to a whole fee GROUP; the backend repurposed the
  // same table/URL to link a student directly to one fee-structure line instead (feeGroupId
  // column -> feeStructId), so it now needs a feeStructId in the PUT body and on the GET path.
  updateFeeStructureToStudent: `/api/admin/assign-fee-group-to-students`, //{schoolId}/{batchId} (PUT) or /{studFeeStrId} (DELETE)
  getAllStudentsForFeeStructure: `/api/admin/assign-fee-group-to-students`, ///{schoolId}/{batchId}/{feeStructId}
  // The assignment DTO above only returns bare name fields, so enrich with this existing
  // single-student lookup (already used elsewhere in the app) for email/registerNumber/class.
  studentDetail: `/api/student`, // /{studentId}/{batchId}
  getAllFeeStructureForCourse: `/api/admin/fee-structure-by-course-id`, // /{schoolId}/{batchId}/{courseId}
  updateStudentPayment: `/api/admin/student-payment`, // /{schoolId}/{studentId}
  getStudentPayments: `/api/admin/student-payment-history`, // /{schoolId}/{batchId}/{studentId}/{courseId}
  deleteFeeGroup: `/api/admin/fee-group`, // /{feeGroupId}
  deleteFeeStructure: `/api/admin/fee-structure`, // /{feeStructId}
  adjustStudentFee: `/api/admin/adjust-student-fee`, // /{schoolId}/{batchId}/{studentId} (GET, POST) or /{adjustFeeId} (PUT, DELETE)
  getAllAdjustStudentFee: `/api/admin/all-adjust-student-fee`, // /{schoolId}/{batchId}
  createStudentFeeRefund: `/api/admin/student-fee-refunds`, // POST
  studentFeeRefundsByPayment: `/api/admin/student-fee-refunds/payment`, // /{studPaymentId} and /{studPaymentId}/total
  studentFeeRefundsByStudent: `/api/admin/student-fee-refunds/student`, // /{studentId}/batch/{batchId}
};

export const GET_ALL_FEE_GROUPS = 'GET_ALL_FEE_GROUPS';
export const getAllFeeGroups = feeGroups => ({
  type: GET_ALL_FEE_GROUPS,
  feeGroups,
});

export const GET_ALL_FEE_STRUCTURES = 'GET_ALL_FEE_STRUCTURES';
export const getAllFeeStructures = (feeStructures, feeGroupId) => ({
  type: GET_ALL_FEE_STRUCTURES,
  feeStructures,
  feeGroupId,
});

export const GET_ALL_COURSES_FOR_GROUP = 'GET_ALL_COURSES_FOR_GROUP';
export const getAllCoursesForGroup = courseListForFeeGroup => ({
  type: GET_ALL_COURSES_FOR_GROUP,
  courseListForFeeGroup,
});

export const GET_ALL_STUDENTS_FOR_FEE_STRUCTURE = 'GET_ALL_STUDENTS_FOR_FEE_STRUCTURE';
export const getAllStudentsForFeeStructure = (studentListForFeeStructure, feeStructId) => ({
  type: GET_ALL_STUDENTS_FOR_FEE_STRUCTURE,
  studentListForFeeStructure,
  feeStructId,
});

export const GET_STUDENT_DETAIL = 'GET_STUDENT_DETAIL';
export const getStudentDetail = (studentDetail, studentId) => ({
  type: GET_STUDENT_DETAIL,
  studentDetail,
  studentId,
});

export const GET_ALL_FEES_STRUCTURE_FOR_COURSE = 'GET_ALL_FEES_STRUCTURE_FOR_COURSE';
export const getAllFeeStructureForCourses = (feeStructureForCourse, courseId) => ({
  type: GET_ALL_FEES_STRUCTURE_FOR_COURSE,
  feeStructureForCourse,
  courseId,
});

export const GET_STUDENT_PAYMENTS = 'GET_STUDENT_PAYMENTS';
export const getStudentPayments = studentPayments => ({
  type: GET_STUDENT_PAYMENTS,
  studentPayments,
});

export const GET_ADJUST_STUDENT_FEE = 'GET_ADJUST_STUDENT_FEE';
export const getAdjustStudentFee = (adjustStudentFeeList, studentId) => ({
  type: GET_ADJUST_STUDENT_FEE,
  adjustStudentFeeList,
  studentId,
});

export const GET_REFUNDS_FOR_PAYMENT = 'GET_REFUNDS_FOR_PAYMENT';
export const getRefundsForPayment = (refunds, studPaymentId) => ({
  type: GET_REFUNDS_FOR_PAYMENT,
  refunds,
  studPaymentId,
});

export const GET_REFUND_TOTAL_FOR_PAYMENT = 'GET_REFUND_TOTAL_FOR_PAYMENT';
export const getRefundTotalForPayment = (total, studPaymentId) => ({
  type: GET_REFUND_TOTAL_FOR_PAYMENT,
  total,
  studPaymentId,
});

export const GET_REFUNDS_FOR_STUDENT = 'GET_REFUNDS_FOR_STUDENT';
export const getRefundsForStudent = (refunds, studentId) => ({
  type: GET_REFUNDS_FOR_STUDENT,
  refunds,
  studentId,
});

export const GET_ALL_ADJUST_STUDENT_FEE = 'GET_ALL_ADJUST_STUDENT_FEE';
export const getAllAdjustStudentFee = allAdjustStudentFeeList => ({
  type: GET_ALL_ADJUST_STUDENT_FEE,
  allAdjustStudentFeeList,
});

export const SET_FEES_COMMON_PARAM = 'SET_FEES_COMMON_PARAM';
export const setFeesCommonParam = (paramName, value) => {
  store.dispatch({
    type: SET_FEES_COMMON_PARAM,
    paramName,
    value,
  });
};

const BASE = constants.API_BASE_URL;

export const addFeeGroupService = data => async () => {
  const { schoolId, token, postData } = data;
  return axios.put(`${BASE}${APIS['updateGroup']}/${schoolId}`, postData, constants.setHeader(token));
};

export const fetchAllFeeGroupService = data => async dispatch => {
  const { schoolId, token } = data;
  try {
    const res = await axios.get(`${BASE}${APIS['getAllGroup']}/${schoolId}`, constants.setHeader(token));
    dispatch(getAllFeeGroups(res.data));
  } catch (err) {
    console.error('err-fetchAllFeeGroupService', err);
  }
};

export const addFeeStructureService = data => async () => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, feeGroupId, token, postData } = data;
  return axios.put(
    `${BASE}${APIS['updateFeeStructure']}/${schoolId}/${batchId}/${feeGroupId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchAllFeeStructureService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, feeGroupId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getAllFeeStructureByGroupId']}/${schoolId}/${batchId}/${feeGroupId}`,
      constants.setHeader(token)
    );
    dispatch(getAllFeeStructures(res.data, feeGroupId));
  } catch (err) {
    console.error('err-fetchAllFeeStructureService', err);
  }
};

export const addFeeGroupToCourseService = data => async () => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, token, postData } = data;
  return axios.put(
    `${BASE}${APIS['updateFeeGroupToCourse']}/${schoolId}/${batchId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchAllCourseForFeeGroup = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getAllCoursesForGroup']}/${schoolId}/${batchId}`,
      constants.setHeader(token)
    );
    dispatch(getAllCoursesForGroup(res.data));
  } catch (err) {
    console.error('err-fetchAllCourseForFeeGroup', err);
  }
};

export const saveAssignedStudentForFeeStructureService = data => async () => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, token, postData } = data;
  return axios.put(
    `${BASE}${APIS['updateFeeStructureToStudent']}/${schoolId}/${batchId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchAllStudentsForFeeStructureService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, feeStructId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getAllStudentsForFeeStructure']}/${schoolId}/${batchId}/${feeStructId}`,
      constants.setHeader(token)
    );
    dispatch(getAllStudentsForFeeStructure(res.data, feeStructId));
    return res.data;
  } catch (err) {
    console.error('err-fetchAllStudentsForFeeStructureService', err);
  }
};

export const fetchStudentDetailService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { studentId, token } = data;
  try {
    const res = await axios.get(`${BASE}${APIS['studentDetail']}/${studentId}/${batchId}`, constants.setHeader(token));
    dispatch(getStudentDetail(res.data, studentId));
  } catch (err) {
    console.error('err-fetchStudentDetailService', err);
  }
};

export const deleteAssignedStudentForFeeStructureService = data => async () => {
  const { studFeeStrId, token } = data;
  return axios.delete(`${BASE}${APIS['updateFeeStructureToStudent']}/${studFeeStrId}`, constants.setHeader(token));
};

export const fetchAllFeeStructureForCourseService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, courseId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getAllFeeStructureForCourse']}/${schoolId}/${batchId}/${courseId}`,
      constants.setHeader(token)
    );
    dispatch(getAllFeeStructureForCourses(res.data, courseId));
  } catch (err) {
    console.error('err-fetchAllFeeStructureForCourseService', err);
  }
};

export const addStudentPayment = data => async () => {
  const { schoolId, studentId, token, postData } = data;
  return axios.post(
    `${BASE}${APIS['updateStudentPayment']}/${schoolId}/${studentId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchStudentPaymentsService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, courseId, studentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getStudentPayments']}/${schoolId}/${batchId}/${studentId}/${courseId}`,
      constants.setHeader(token)
    );
    dispatch(getStudentPayments(res.data));
  } catch (err) {
    console.error('err-fetchStudentPaymentsService', err);
  }
};

export const deleteFeeGroupService = data => async () => {
  const { feeGroupId, token } = data;
  return axios.delete(`${BASE}${APIS['deleteFeeGroup']}/${feeGroupId}`, constants.setHeader(token));
};

export const deleteFeeStructureService = data => async () => {
  const { feeStructId, token } = data;
  return axios.delete(`${BASE}${APIS['deleteFeeStructure']}/${feeStructId}`, constants.setHeader(token));
};

export const addAdjustStudentFeeService = data => async () => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, studentId, token, postData } = data;
  return axios.post(
    `${BASE}${APIS['adjustStudentFee']}/${schoolId}/${batchId}/${studentId}`,
    postData,
    constants.setHeader(token)
  );
};

export const updateAdjustStudentFeeService = data => async () => {
  const { adjustFeeId, token, postData } = data;
  return axios.put(`${BASE}${APIS['adjustStudentFee']}/${adjustFeeId}`, postData, constants.setHeader(token));
};

export const deleteAdjustStudentFeeService = data => async () => {
  const { adjustFeeId, token } = data;
  return axios.delete(`${BASE}${APIS['adjustStudentFee']}/${adjustFeeId}`, constants.setHeader(token));
};

export const fetchAdjustStudentFeeService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, studentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['adjustStudentFee']}/${schoolId}/${batchId}/${studentId}`,
      constants.setHeader(token)
    );
    dispatch(getAdjustStudentFee(res.data, studentId));
    return res.data;
  } catch (err) {
    console.error('err-fetchAdjustStudentFeeService', err);
  }
};

export const fetchAllAdjustStudentFeeService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { schoolId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['getAllAdjustStudentFee']}/${schoolId}/${batchId}`,
      constants.setHeader(token)
    );
    dispatch(getAllAdjustStudentFee(res.data));
  } catch (err) {
    console.error('err-fetchAllAdjustStudentFeeService', err);
  }
};

export const createStudentFeeRefundService = data => async () => {
  const { token, ...postData } = data;
  return axios.post(`${BASE}${APIS['createStudentFeeRefund']}`, postData, constants.setHeader(token));
};

export const fetchRefundsForPaymentService = data => async dispatch => {
  const { studPaymentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['studentFeeRefundsByPayment']}/${studPaymentId}`,
      constants.setHeader(token)
    );
    dispatch(getRefundsForPayment(res.data, studPaymentId));
  } catch (err) {
    console.error('err-fetchRefundsForPaymentService', err);
  }
};

export const fetchRefundTotalForPaymentService = data => async dispatch => {
  const { studPaymentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['studentFeeRefundsByPayment']}/${studPaymentId}/total`,
      constants.setHeader(token)
    );
    dispatch(getRefundTotalForPayment(res.data, studPaymentId));
  } catch (err) {
    console.error('err-fetchRefundTotalForPaymentService', err);
  }
};

export const fetchRefundsForStudentBatchService = data => async dispatch => {
  const { batchId = data?.batchId } = getGlobalCurrentBatchUtils();
  const { studentId, token } = data;
  try {
    const res = await axios.get(
      `${BASE}${APIS['studentFeeRefundsByStudent']}/${studentId}/batch/${batchId}`,
      constants.setHeader(token)
    );
    dispatch(getRefundsForStudent(res.data, studentId));
    return res.data;
  } catch (err) {
    console.error('err-fetchRefundsForStudentBatchService', err);
  }
};
